// extracted by mini-css-extract-plugin
export default {"optionLabel":"FlagInput_optionLabel__rj4an","flag":"FlagInput_flag__VgG-D"};